import React, { useMemo } from 'react';
import { Auth0Provider as Auth0ProviderSDK } from '@auth0/auth0-react';
import { DevAuthEntryScreen } from './DevAuthEntryScreen';
import { auth0Config } from '../auth/auth0-config';

/**
 * Local-only preview route for the production auth entry UX.
 *
 * Why this exists:
 * - On localhost we intentionally bypass Auth0/AuthGuard to enable UI work without auth.
 * - That means the real Auth0LoginScreen normally never renders locally.
 * - This page mounts the real Auth0Provider and renders the branded Auth0 login entry screen
 *   so we can visually verify styles on localhost.
 */
export const AuthEntryPreview: React.FC = () => {
  const redirectUri = useMemo(() => {
    // For preview we still send callbacks to localhost so the flow can complete if desired.
    return `${window.location.origin}/auth/callback`;
  }, []);

  return (
    <Auth0ProviderSDK
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
        ...auth0Config.authorizationParams,
      }}
      useRefreshTokens={auth0Config.useRefreshTokens}
      cacheLocation={auth0Config.cacheLocation}
      httpTimeoutInSeconds={auth0Config.httpTimeoutInSeconds}
    >
      <DevAuthEntryScreen />
    </Auth0ProviderSDK>
  );
};


